// export default function CallIcon({color, fill}){
//     return(
//         <svg width="22" height="22" viewBox="0 0 24 24" fill={fill} xmlns="http://www.w3.org/2000/svg">
//             {/* Phone handset */}
//             <path d="M6.62 10.79C8.06 13.62 10.38 15.93 13.21 17.38L15.41 15.18C15.68 14.91 16.08 14.82 16.43 14.94C17.55 15.31 18.76 15.51 20 15.51C20.55 15.51 21 15.96 21 16.51V20C21 20.55 20.55 21 20 21C10.61 21 3 13.39 3 4C3 3.45 3.45 3 4 3H7.5C8.05 3 8.5 3.45 8.5 4C8.5 5.25 8.7 6.45 9.07 7.57C9.18 7.92 9.1 8.31 8.82 8.59L6.62 10.79Z"
//             stroke={color} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/>
//             {/* Small wave */}
//             <path d="M15.5 5.5C16.5 6.5 17 7.5 17 9"
//             stroke={color} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/>
//             {/* Medium wave */}
//             <path d="M17.5 3.5C19.33 5.0 20.5 7.1 20.5 9.5"
//             stroke={color} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/>
//         </svg>
//     )
// }

export default function CallIcon({
  color = "#667085",
  fill = "none",
  width = 22,
  height = 22,
}) {
  const isActive = fill !== "none";

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
    >
      {isActive ? (
        <>
          {/* 1️⃣ Filled handset — rendered FIRST (bottom layer) */}
          <path
            d="M6.54 5C6.6 5.89 6.75 6.76 6.99 7.59L5.79 8.79C5.38 7.59 5.12 6.32 5.04 5H6.54ZM16.4 17.02C17.25 17.26 18.12 17.41 19 17.47V18.95C17.68 18.87 16.41 18.61 15.2 18.21L16.4 17.02ZM7.5 3H4C3.45 3 3 3.45 3 4C3 13.39 10.61 21 20 21C20.55 21 21 20.55 21 20V16.51C21 15.96 20.55 15.51 20 15.51C18.76 15.51 17.55 15.31 16.43 14.94C16.08 14.82 15.69 14.91 15.41 15.18L13.21 17.38C10.38 15.93 8.06 13.62 6.62 10.79L8.82 8.59C9.1 8.31 9.18 7.92 9.07 7.57C8.7 6.45 8.5 5.25 8.5 4C8.5 3.45 8.05 3 7.5 3Z"
            fill={fill}
            stroke={fill}
            strokeWidth="0.5"
          />

          {/* 2️⃣ Small wave — rendered LAST (top layer) with strong visible color */}
          <path
            d="M15.5 5.5C16.5 6.5 17 7.5 17 9"
            stroke={fill}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill={fill}
          />

          {/* 3️⃣ Medium wave — rendered LAST (top layer) */}
          <path
            d="M17.5 3.5C19.33 5.0 20.5 7.1 20.5 9.5"
            stroke={fill}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill={fill}
          />
        </>
      ) : (
        <>
          <path
            d="M6.62 10.79C8.06 13.62 10.38 15.93 13.21 17.38L15.41 15.18C15.68 14.91 16.08 14.82 16.43 14.94C17.55 15.31 18.76 15.51 20 15.51C20.55 15.51 21 15.96 21 16.51V20C21 20.55 20.55 21 20 21C10.61 21 3 13.39 3 4C3 3.45 3.45 3 4 3H7.5C8.05 3 8.5 3.45 8.5 4C8.5 5.25 8.7 6.45 9.07 7.57C9.18 7.92 9.1 8.31 8.82 8.59L6.62 10.79Z"
            stroke={color}
            strokeWidth="2.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15.5 5.5C16.5 6.5 17 7.5 17 9"
            stroke={color}
            strokeWidth="2.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.5 3.5C19.33 5.0 20.5 7.1 20.5 9.5"
            stroke={color}
            strokeWidth="2.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      )}
    </svg>
  );
}